export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-simple-flow/index.js